export const REGISTRATION_SOURCE = {
  NOT_SET: 'REGISTRATION_SOURCE_NOT_SET',
  COMMUNITY: 'REGISTRATION_SOURCE_COMMUNITY',
  TWILIO_TRUST_HUB: 'REGISTRATION_SOURCE_TWILIO_TRUST_HUB',
} as const

export type RegistrationSource = typeof REGISTRATION_SOURCE[keyof typeof REGISTRATION_SOURCE]
